import { Injectable } from '@angular/core';
import { IRequestCallback } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { NSamples } from '@df/samples/samples.namespace';
import { Basket } from '@df/session/api/basket/basket';

@Injectable({
    providedIn: 'root'
})
export class SamplesBasket extends Basket {
    readonly isSamplesBasket = true;

    load() {
        return this.request.send(undefined, { path: NSamples.ENDPOINTS.loadQuote });
    }

    addCoupon(status: Status, data, onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        data.sampleQuote = true;
        return super.addCoupon(status, data, onSuccess, onError);
    }

    formAddCoupon(form: any, status: Status, data, onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        data.sampleQuote = true;
        return super.formAddCoupon(form, status, data, onSuccess, onError);
    }

    removeCoupon(status: Status, data, onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        data.sampleQuote = true;
        return super.removeCoupon(status, data, onSuccess, onError);
    }

    protected register() {
        this.customer.register(
            {
                id: 'samplesBasket',
                listener: 'samplesBasket',
                account: false
            },
            this
        );
    }
}
